import { useEffect, type ReactNode } from "react";
import MarketingNavbar from "./MarketingNavbar";
import MarketingFooter from "./MarketingFooter";

export function useFadeUp() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.1 }
    );
    const observeAll = () => {
      document.querySelectorAll<HTMLElement>(".marketing-scope .fade-up:not(.visible):not([data-fadeup-bound])").forEach((el) => {
        el.dataset.fadeupBound = "1";
        io.observe(el);
      });
    };
    observeAll();
    const root = document.querySelector(".marketing-scope") || document.body;
    const mo = new MutationObserver(() => observeAll());
    mo.observe(root, { childList: true, subtree: true });
    const fallback = window.setTimeout(() => {
      document.querySelectorAll(".marketing-scope .fade-up:not(.visible)").forEach((el) => el.classList.add("visible"));
    }, 1500);
    return () => { io.disconnect(); mo.disconnect(); window.clearTimeout(fallback); };
  }, []);
}

export default function MarketingShell({
  children,
  showNavbar = true,
  showFooter = true,
}: {
  children: ReactNode;
  showNavbar?: boolean;
  showFooter?: boolean;
}) {
  useFadeUp();
  return (
    <div className="marketing-scope" dir="rtl">
      {showNavbar && <MarketingNavbar />}
      {children}
      {showFooter && <MarketingFooter />}
    </div>
  );
}
